"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackRemoveIssueAnnotationSuccess = exports.trackQRPReportConfirm = exports.trackQRPReportCompleted = exports.trackIssueThumbnailRetake = exports.trackIssueThumbnailOpenFromActivityPanel = exports.trackIssueThumbnailOpen = exports.trackIssueThumbnailAnnotateClick = exports.trackIssueSnapshotStatus = exports.trackIssueSnapshotNavigateAway = exports.trackIssueSnapshotCreate = exports.trackIssueReferenceRemove = exports.trackIssueReferenceAdd = exports.trackIssueCustomFieldEdit = exports.trackIssueCreateSuccess = exports.trackIssueCreateMarkupTypeSearch = exports.trackIssueCreateMarkupTypeClick = exports.trackIssueCreateMarkupTypeClearSearch = exports.trackIssueCreateMarkupClick = exports.trackIssueCreateEditField = exports.trackIssueCreateClick = exports.trackIssueCreateCancelConfirmation = exports.trackIssueCreateCancel = exports.trackIssueBulkEditSuccess = exports.trackIssueBulkEditPartialFailure = exports.trackIssueBulkEditFailure = exports.trackIssueBaseFieldEdit = exports.trackIssueAttachmentRemove = exports.trackIssueAttachmentClick = exports.trackIssueAttachmentAdd = exports.trackIssueAddComment = exports.trackEditSelectAll = exports.trackEditSelect = exports.trackBulkEditUnpublishAction = exports.trackBulkEditPublishAction = exports.trackBulkEditClickAction = void 0;
var _difference = _interopRequireDefault(require("lodash/difference"));
var _sdk = require("../../../sdk");
var _trackEvent = require("./trackEvent");
var _analyticsLib093IssuesEvents = require("./analyticsLib093IssuesEvents");
var _issueEditBulkEditUnpublishEvent = require("./issueEdit/issueEditBulkEditUnpublishEvent");
var _issueEditBulkEditPublishEvent = require("./issueEdit/issueEditBulkEditPublishEvent");
var _issueEditBulkEditClickEvent = require("./issueEdit/issueEditBulkEditClickEvent");
var _issueEditSelectEvent = require("./issueEdit/issueEditSelectEvent");
var _issueEditSelectAllEvent = require("./issueEdit/issueEditSelectAllEvent");
var _getCommentsMentionAnalytics = require("./utils/getCommentsMentionAnalytics");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const trackIssueCreateClick = () => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueCreateClickAnalyticsEvent());
};
exports.trackIssueCreateClick = trackIssueCreateClick;
const trackIssueCreateMarkupClick = () => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueCreateMarkupClickAnalyticsEvent());
};
exports.trackIssueCreateMarkupClick = trackIssueCreateMarkupClick;
const trackIssueCreateMarkupTypeClick = () => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueCreateMarkupTypeClickAnalyticsEvent());
};
exports.trackIssueCreateMarkupTypeClick = trackIssueCreateMarkupTypeClick;
const trackIssueCreateMarkupTypeSearch = () => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueCreateMarkupTypeSearchAnalyticsEvent());
};
exports.trackIssueCreateMarkupTypeSearch = trackIssueCreateMarkupTypeSearch;
const trackIssueCreateMarkupTypeClearSearch = () => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueCreateMarkupTypeClearSearchAnalyticsEvent());
};
exports.trackIssueCreateMarkupTypeClearSearch = trackIssueCreateMarkupTypeClearSearch;
const trackIssueThumbnailOpen = () => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueThumbnailOpenAnalyticsEvent());
};
exports.trackIssueThumbnailOpen = trackIssueThumbnailOpen;
const trackIssueThumbnailOpenFromActivityPanel = () => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueThumbnailOpenFromActivityLogAnalyticsEvent());
};
exports.trackIssueThumbnailOpenFromActivityPanel = trackIssueThumbnailOpenFromActivityPanel;
const trackIssueThumbnailRetake = keepOldThumbnail => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueThumbnailRetakeAnalyticsEvent({
    keepOldThumbnail
  }));
};
exports.trackIssueThumbnailRetake = trackIssueThumbnailRetake;
const trackIssueThumbnailAnnotateClick = issueId => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueThumbnailAnnotateClickAnalyticsEvent({
    issueId
  }));
};
exports.trackIssueThumbnailAnnotateClick = trackIssueThumbnailAnnotateClick;
const trackIssueSnapshotNavigateAway = () => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueSnapshotNavigateAwayAnalyticsEvent());
};
exports.trackIssueSnapshotNavigateAway = trackIssueSnapshotNavigateAway;
const trackIssueSnapshotCreate = _ref => {
  let {
    issueId,
    trigger
  } = _ref;
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueSnapshotCreateAnalyticsEvent({
    issueId,
    trigger
  }));
};
exports.trackIssueSnapshotCreate = trackIssueSnapshotCreate;
const trackIssueSnapshotStatus = _ref2 => {
  let {
    issueId,
    hasMarkups,
    hres,
    vres
  } = _ref2;
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueSnapshotStatusAnalyticsEvent({
    issueId,
    hasMarkups,
    hres,
    vres
  }));
};
exports.trackIssueSnapshotStatus = trackIssueSnapshotStatus;
const trackIssueCreateCancel = () => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueCreateCancelAnalyticsEvent());
};

//currently not being used since it reqires some modification to the CreationModal
exports.trackIssueCreateCancel = trackIssueCreateCancel;
const trackIssueCreateCancelConfirmation = action => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueCreateCancelConfirmationAnalyticsEvent({
    issue_create_cancel_confirmation_action: action
  }));
};

// this needs to be imperative, not a hook, because some contexts will create issues imperatively.
exports.trackIssueCreateCancelConfirmation = trackIssueCreateCancelConfirmation;
const trackIssueCreateSuccess = _ref3 => {
  let {
    issue,
    context = {
      referencePicker: "unknown",
      placement: "unknown",
      documentFileType: undefined,
      origin: "unknown"
    }
  } = _ref3;
  // @TODO I think we need to pass a snapshot of a lot of state into this function to gather
  // the necessary pieces of data... holding off on that until the rest of analytics is in place.
  // If there's a while, even in prod, where we track just the ids in these fields, that's ok
  const typeName = "id:" + issue.issueTypeId; // @TODO resolve this to type name
  const categoryName = "id:" + issue.issueTypeCategoryId; // @TODO resolve this to a category name
  const rootCauseName = "id:" + issue.rootCauseId; // @TODO resolve this to a root cause name
  const dropdownTitles = issue.customAttributes ? issue.customAttributes.filter(attribute => attribute.type === _sdk.IssueCustomAttributeType.List).map(dropdownAttribute => dropdownAttribute.title) : [];
  const numericTitles = issue.customAttributes ? issue.customAttributes.filter(attribute => attribute.type === _sdk.IssueCustomAttributeType.Numeric).map(dropdownAttribute => dropdownAttribute.title) : [];
  const paragraphTitles = issue.customAttributes ? issue.customAttributes.filter(attribute => attribute.type === _sdk.IssueCustomAttributeType.Paragraph).map(dropdownAttribute => dropdownAttribute.title) : [];
  const textTitles = issue.customAttributes ? issue.customAttributes.filter(attribute => attribute.type === _sdk.IssueCustomAttributeType.Text).map(dropdownAttribute => dropdownAttribute.title) : [];
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueCreateSuccessAnalyticsEvent({
    issueUid: issue.id,
    displayId: issue.displayId,
    isPublished: issue.published,
    title: issue.title,
    // typescript says status can be undefined in the Issue, but not in the analytics event...
    // so we default it to open (although that default shouldn't ever actually have to happen)
    status: issue.status || "open",
    description: issue.description,
    assignee: issue.assignedTo || undefined,
    watchers: "" + (issue.watchers || []).length,
    startDate: issue.startDate,
    dueDate: issue.dueDate,
    location: issue.locationId,
    locationDetails: issue.locationDetails,
    linkedDocuments: issue.linkedDocuments,
    type: typeName,
    category: categoryName,
    rootCause: rootCauseName,
    dropdown: dropdownTitles,
    numeric: numericTitles,
    paragraph: paragraphTitles,
    text: textTitles,
    ...context
  }));
};
exports.trackIssueCreateSuccess = trackIssueCreateSuccess;
const trackIssueCreateEditField = fieldTypes => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueCreateEditFieldAnalyticsEvent({
    field_type: fieldTypes
  }));
};

// name: "issue.edit.save"
// description: "An issue is edited"
// -- this should only be used for normal fields, for custom fields use trackIssueCustomFieldEdit
exports.trackIssueCreateEditField = trackIssueCreateEditField;
const trackIssueBaseFieldEdit = _ref4 => {
  let {
    issue,
    issueChanges,
    issueSubResources
  } = _ref4;
  Object.entries({
    ...issueChanges,
    ...issueSubResources
  }).forEach(_ref5 => {
    let [key, value] = _ref5;
    const analyticsField = _analyticsLib093IssuesEvents.BASE_ISSUE_ATTRIBUTE_TO_ANALYTICS_FIELD[key];
    if (analyticsField) {
      (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueEditSaveAnalyticsEvent({
        issueUid: issue.id,
        field: analyticsField,
        // coerce these to strings for typescript, since they can be numbers too
        oldFieldValue: "" + (issue[key] || ""),
        editedFieldValue: "" + (value || "")
      }));
    }
    if (key === "watchers") {
      const beforeUserIds = issue.watchers || [];
      const afterUserIds = value;
      const watchersAdded = (0, _difference.default)(afterUserIds, beforeUserIds);
      const watchersRemoved = (0, _difference.default)(beforeUserIds, afterUserIds);
      if (watchersAdded.length) {
        (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueEditSaveAnalyticsEvent({
          issueUid: issue.id,
          field: "watcher_added",
          // coerce these to strings for typescript, since they are arrays
          watcherCt: "" + watchersAdded.length,
          oldFieldValue: "" + beforeUserIds.length,
          editedFieldValue: "" + afterUserIds.length
        }));
      }
      if (watchersRemoved.length) {
        (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueEditSaveAnalyticsEvent({
          issueUid: issue.id,
          field: "watcher_removed",
          // coerce these to strings for typescript, since they are arrays
          watcherCt: "" + watchersRemoved.length,
          oldFieldValue: "" + beforeUserIds.length,
          editedFieldValue: afterUserIds ? String(afterUserIds.length) : "0"
        }));
      }
    }
  });
};
exports.trackIssueBaseFieldEdit = trackIssueBaseFieldEdit;
const trackIssueCustomFieldEdit = _ref6 => {
  let {
    issueUid,
    issueAttribute,
    oldValue,
    newValue
  } = _ref6;
  if (!issueAttribute) {
    return;
  }
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueEditSaveAnalyticsEvent({
    issueUid: issueUid,
    field: "cf_".concat(issueAttribute.type, "_type"),
    oldFieldValue: oldValue || "",
    editedFieldValue: newValue || "",
    customFieldName: issueAttribute.title
  }));
};

//  name: "issue.reference.add"
//  description: "When a reference between an issue and another object is created"
exports.trackIssueCustomFieldEdit = trackIssueCustomFieldEdit;
const trackIssueReferenceAdd = _ref7 => {
  let {
    issueUid,
    objectUid,
    objectType
  } = _ref7;
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueReferenceAddAnalyticsEvent({
    issueUid,
    objectUid,
    objectType
  }));
};

//   name: "issue.reference.remove"
//   description: "When a reference between an issue and another object is created"
exports.trackIssueReferenceAdd = trackIssueReferenceAdd;
const trackIssueReferenceRemove = _ref8 => {
  let {
    issueUid,
    objectUid,
    objectType
  } = _ref8;
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueReferenceRemoveAnalyticsEvent({
    issueUid,
    objectUid,
    objectType
  }));
};
exports.trackIssueReferenceRemove = trackIssueReferenceRemove;
const trackIssueAttachmentAdd = _ref9 => {
  let {
    attachmentFileType
  } = _ref9;
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueAttachmentAddAnalyticsEvent({
    attachmentFileType
  }));
};
exports.trackIssueAttachmentAdd = trackIssueAttachmentAdd;
const trackIssueAttachmentRemove = _ref10 => {
  let {
    attachmentFileType
  } = _ref10;
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueAttachmentRemoveAnalyticsEvent({
    attachmentFileType
  }));
};
exports.trackIssueAttachmentRemove = trackIssueAttachmentRemove;
const trackIssueAttachmentClick = _ref11 => {
  let {
    attachmentFileType
  } = _ref11;
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueAttachmentClickAnalyticsEvent({
    attachmentFileType
  }));
};
exports.trackIssueAttachmentClick = trackIssueAttachmentClick;
const trackIssueBulkEditSuccess = _ref12 => {
  let {
    selectedCount,
    changedFields
  } = _ref12;
  // @TODO when the infra is fixed we can consume the latest version of
  // PG's analytics lib in the adsk context, create this event in that library and use it
  (0, _trackEvent.trackEvent)({
    name: "issue.edit.bulk_edit.success",
    parameters: {
      selected_count: selectedCount,
      changedFields
    }
  });
};
exports.trackIssueBulkEditSuccess = trackIssueBulkEditSuccess;
const trackIssueBulkEditPartialFailure = _ref13 => {
  let {
    successCount,
    failureCount
  } = _ref13;
  // @TODO when the infra is fixed we can consume the latest version of
  // PG's analytics lib in the adsk context, create this event in that library and use it
  (0, _trackEvent.trackEvent)({
    name: "issue.edit.bulk_edit.partial_failure",
    parameters: {
      success_count: successCount,
      failure_count: failureCount
    }
  });
};
exports.trackIssueBulkEditPartialFailure = trackIssueBulkEditPartialFailure;
const trackIssueBulkEditFailure = _ref14 => {
  let {
    selectedCount
  } = _ref14;
  // @TODO when the infra is fixed we can consume the latest version of
  // PG's analytics lib in the adsk context, create this event in that library and use it
  (0, _trackEvent.trackEvent)({
    name: "issue.edit.bulk_edit.fail",
    parameters: {
      selected_count: selectedCount
    }
  });
};
exports.trackIssueBulkEditFailure = trackIssueBulkEditFailure;
const trackBulkEditUnpublishAction = _ref15 => {
  let {
    selectedCount
  } = _ref15;
  (0, _trackEvent.trackEvent)(new _issueEditBulkEditUnpublishEvent.IssueEditBulkEditUnpublishEvent({
    selectedCount
  }));
};
exports.trackBulkEditUnpublishAction = trackBulkEditUnpublishAction;
const trackBulkEditPublishAction = _ref16 => {
  let {
    selectedCount
  } = _ref16;
  (0, _trackEvent.trackEvent)(new _issueEditBulkEditPublishEvent.IssueEditBulkEditPublishEvent({
    selectedCount
  }));
};
exports.trackBulkEditPublishAction = trackBulkEditPublishAction;
const trackBulkEditClickAction = () => {
  (0, _trackEvent.trackEvent)(new _issueEditBulkEditClickEvent.IssueEditBulkEditClickEvent());
};
exports.trackBulkEditClickAction = trackBulkEditClickAction;
const trackEditSelect = () => {
  (0, _trackEvent.trackEvent)(new _issueEditSelectEvent.IssueEditSelectEvent());
};
exports.trackEditSelect = trackEditSelect;
const trackEditSelectAll = () => {
  (0, _trackEvent.trackEvent)(new _issueEditSelectAllEvent.IssueEditSelectAllEvent());
};
exports.trackEditSelectAll = trackEditSelectAll;
const trackIssueAddComment = _ref17 => {
  let {
    comment,
    users,
    rolesList,
    companiesList
  } = _ref17;
  const numOfCharacters = comment.length;
  const mentionsAnalyticsData = (0, _getCommentsMentionAnalytics.getCommentsMentionAnalytics)({
    comment,
    users,
    rolesList,
    companiesList
  });
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueAddCommentsAnalyticsEvent({
    commentCharacters: numOfCharacters,
    ...mentionsAnalyticsData
  }));
};
exports.trackIssueAddComment = trackIssueAddComment;
const trackRemoveIssueAnnotationSuccess = _ref18 => {
  let {
    issue_uid,
    sheet_uid
  } = _ref18;
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.IssueRemoveIssueAnnotationSuccessAnalyticsEvent({
    issue_uid,
    sheet_uid
  }));
};
exports.trackRemoveIssueAnnotationSuccess = trackRemoveIssueAnnotationSuccess;
const trackQRPReportConfirm = params => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.QRPReportConfirmEvent(params));
};
exports.trackQRPReportConfirm = trackQRPReportConfirm;
const trackQRPReportCompleted = params => {
  (0, _trackEvent.trackEvent)(new _analyticsLib093IssuesEvents.QRPReportCompletedEvent(params));
};
exports.trackQRPReportCompleted = trackQRPReportCompleted;
//# sourceMappingURL=issueActionsTracking.js.map